import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import { createUseStyles } from '../../../utils/styles';

import Step from './Step';
import styles from './styles';

const useStyles = createUseStyles(styles, 'Steps');

function Steps({
    classes: classesProp,
    overrides: overridesProp,
    className,
    onClick,
    steps = [],
    currentStep = 1,
    ...props
}) {
    const classes = useClasses(useStyles, classesProp);
    const override = getOverrides(overridesProp, Steps.overrides);

    return (
        <div className={classnames(classes.root, className)} {...override.root} {...props}>
            <div className={classes.stepsContainer}>
                {steps.map((step, i) => (
                    <Step
                        key={i}
                        step={step}
                        index={i}
                        currentStep={currentStep}
                        classes={classes}
                        onClick={onClick}
                        showConnector={i < steps.length - 1}
                    />
                ))}
            </div>
        </div>
    );
}

Steps.overrides = ['root'];

Steps.propTypes = {
    /** Custom CSS class for styling the root container */
    className: PropTypes.string,
    /** Object with custom style overrides */
    overrides: PropTypes.object,
    /** Array of step objects defining the Steps navigation */
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            /** Text label displayed for the step */
            title: PropTypes.string,
            /** When true, the step is marked as completed with a check icon */
            isCompleted: PropTypes.bool,
        }),
    ),
    /** One-based index of the current active step */
    currentStep: PropTypes.number,
    /** Callback function triggered when a step is clicked. Receives the step index as parameter */
    onClick: PropTypes.func,
};

export default memo(Steps);
